/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";
import {useMutation, useQuery} from "@apollo/react-hooks";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {CREATE_TEAM, GET_TEAM, UPDATE_TEAM} from "../../database/queries/teamQueries";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import BackupOutlinedIcon from "@material-ui/icons/BackupOutlined";
import ClearIcon from "@material-ui/icons/Clear";
import {notify} from "../../utils/notify";
import usePersistentStore from "../../persistentStore";
import FormHelperText from "@material-ui/core/FormHelperText";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& p': {
            color: 'red',
        }
    },
    gridContainer: {
        overflow: 'auto',
        overflowY: 'scroll',
        padding: 20,
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    rightField: {
        paddingLeft: 10,
    },
    hidden: {
        display: 'none',
    },
    grow: {
        flexGrow: 1,
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
        marginRight: 10,
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
}));

const TeamEdit = props => {
    const classes = useStyles();
    const [team, setTeam] = useState({}); // need this so we dont edit global team
    const [errors, setErrors] = useState({});
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const history = useHistory();

    const {loading: getTeamLoading, error: getTeamError, data: getTeamData} = useQuery(GET_TEAM, {
        skip: !props.editId || props.editId === 'new',
        variables: {teamId: props.editId},
    });

    const [updateTeam, {error: updateTeamError}] = useMutation(UPDATE_TEAM, {
        variables: {
            changedTeam: {
                teamId: team.teamId,
                teamName: team.teamName,
                teamDescription: team.teamDescription,
            }
        }
    });

    const [createTeam, {error: createTeamError}] = useMutation(CREATE_TEAM, {
        variables: {
            newTeam: {
                teamName: team.teamName,
                teamDescription: team.teamDescription,
            }
        }
    });

    useEffect(() => {
        if (createTeamError) notify('createTeamError', 'error', createTeamError.message);
        if (getTeamError) notify('getTeamError', 'error', getTeamError.message);
        if (updateTeamError) notify('updateTeamError', 'error', updateTeamError.message);
    }, [createTeamError, getTeamError, updateTeamError]);

    useEffect(() => {
        if (getTeamData && getTeamData.team) {
            let fetchedTeam = {...getTeamData.team};
            setTeam({...fetchedTeam});
            if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
        }
    }, [getTeamData]);

    useEffect(() => {
    }, [team]);

    useEffect(() => {
        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
    }, []);

    const handleChange = (e) => {
        const updatedTeam = {
            ...team,
            [e.target.name]: e.target.value
        };
        setTeam(updatedTeam);
        if (!globalPersistentState.dirty) globalPersistentActions.setDirty(true);
    };

    const validateForm = () => {
        setErrors({});
        let newError = {};
        if (!team.teamName || team.teamName.length === 0) newError.teamName = 'Team Name cannot be empty';

        if (Object.keys(newError).length > 0) {
            setErrors(newError);
            return false;
        } else {
            return true;
        }
    };

    if (getTeamLoading) return <p>Loading ...</p>;

    return (
        <form className={classes.root}>
            {team && (
                <div>
                    <Paper className={classes.textboxPaper}>
                        <AppBar color="default" position="static" className={classes.noMargin}>
                            <Toolbar className={classes.noMargin}>
                                <div className={classes.grow}/>
                                {globalPersistentState.dirty && <IconButton
                                    aria-label="save team"
                                    id={"save-team"}
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        if (validateForm()) {
                                            if (team.teamId && team.teamId.length > 0 && team.teamId !== 'new') {
                                                updateTeam().then(async (updateResult) => {
                                                    notify('updateTeam', 'info', 'Team updated');
                                                    if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                                    history.goBack();
                                                    props.parentRefresh();
                                                })
                                            } else {
                                                createTeam().then(async (createResult) => {
                                                    notify('createTeam', 'info', 'Team created');
                                                    if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                                    history.goBack();
                                                    props.parentRefresh();
                                                })
                                            }
                                        }
                                    }}>
                                    <BackupOutlinedIcon/>
                                </IconButton>}
                                {globalPersistentState.dirty && <IconButton
                                    aria-label="cancel edit team"
                                    id={"cancel-save-team"}
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        history.goBack();
                                        props.parentRefresh();
                                    }}>
                                    <ClearIcon/>
                                </IconButton>}
                            </Toolbar>
                        </AppBar>

                        <Grid container className={classes.gridContainer}>
                            <Grid item xs={12} className={classes.leftField}>
                                <FormControl
                                    className={errors.teamName ? classes.formControlError : classes.formControl}
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                >
                                    <TextField
                                        required
                                        id="teamName"
                                        name="teamName"
                                        label="Team name"
                                        fullWidth
                                        size="small"
                                        onChange={handleChange}
                                        value={team.teamName}
                                    />
                                    <FormHelperText>
                                        {errors.teamName}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl
                                    className={classes.formControl}
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                >
                                    <TextField
                                        id="teamDescription"
                                        name="teamDescription"
                                        label="Team description"
                                        fullWidth
                                        size="small"
                                        multiline
                                        value={team.teamDescription}
                                        onChange={handleChange}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Paper>
                </div>
            )}
        </form>
    )
};

export default TeamEdit
